import {toString, toBoolean} from "../helpers/helpers";

const DEFAULT_MESSAGE = "You do not have access to this resource.";

export class AccessDeniedError extends Error {
  name: string = "AccessDeniedError";
  message: string;
  allowSelfAssign: boolean;
  projectId: string;
  projectName: string;

  static check(obj: any): boolean {
    if (!obj) return false;

    return obj.name === "AccessDeniedError";
  }

  constructor(json: any) {
    super();
    Object.setPrototypeOf(this, AccessDeniedError.prototype);

    this.message = toString(json.message) || DEFAULT_MESSAGE;
    this.allowSelfAssign = toBoolean(json.allowSelfAssign);
    this.projectId = toString(json.projectId);
    this.projectName = toString(json.projectName);
  }
}
